import { useState, useCallback, type ReactNode } from 'react'
import { Toast, type ToastType, type ToastAction } from './Toast'
import { ToastContext, type ShowToastOptions } from '../hooks/useToast'

interface ToastMessage {
  id: number
  message: string
  type: ToastType
  duration?: number
  action?: ToastAction
}

let toastId = 0

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ToastMessage[]>([])

  const showToast = useCallback((message: string, type: ToastType, options?: ShowToastOptions) => {
    const id = toastId++
    setToasts((prev) => [...prev, { id, message, type, duration: options?.duration, action: options?.action }])
  }, [])

  const removeToast = useCallback((id: number) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="fixed bottom-4 right-4 z-[200] flex flex-col gap-2 items-end pointer-events-none">
        {toasts.map((toast) => (
          <div key={toast.id} className="pointer-events-auto">
            <Toast
              message={toast.message}
              type={toast.type}
              onClose={() => removeToast(toast.id)}
              duration={toast.duration}
              action={toast.action}
            />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  )
}
